// extracted by mini-css-extract-plugin
export default {"title":"commonStyle_title__fOdos","subtitle":"commonStyle_subtitle__ziOHx","text":"commonStyle_text__caoaw","brLine":"commonStyle_brLine__Q-CnV"};